<template>
  <div>
    <b-form-group :label="label" :description="description">
      <b-form-tags
        :value="value"
        @input="$emit('input', $event)"
        no-outer-focus
        class="mb-2"
      >
        <template v-slot="{ tags, disabled, addTag, removeTag }">
          <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag
                @remove="removeTag(tag)"
                :title="tag"
                :disabled="disabled"
                >{{ tag }}</b-form-tag
              >
            </li>
          </ul>
          <b-dropdown
            size="sm"
            variant="outline-secondary"
            block
            menu-class="w-100"
          >
            <template v-slot:button-content>
              <!--<b-icon icon="tag-fill"></b-icon>-->
              Choose tags
            </template>
            <b-dropdown-form @submit.stop.prevent="() => {}">
              <b-form-group
                label-for="tag-search-input"
                label="Search tags"
                label-cols-md="auto"
                class="mb-0"
                label-size="sm"
                :description="searchDesc"
                :disabled="disabled"
              >
                <b-form-input
                  v-model="search"
                  id="tag-search-input"
                  type="search"
                  size="sm"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
            </b-dropdown-form>
            <b-dropdown-divider></b-dropdown-divider>
            <div
              class="dropdown-wrapper"
              :style="{ 'max-height': `${maxHeight}px`, overflow: 'scroll' }"
            >
              <b-dropdown-item-button
                v-for="option in availableOptions"
                :key="option.name"
                @click="onOptionClick({ option: option.name, addTag })"
                button-class="d-flex justify-content-between align-items-center"
              >
                {{ option.name }}
                <b-badge variant="primary" pill>{{ option.count }}</b-badge>
              </b-dropdown-item-button>
              <b-dropdown-text v-if="availableOptions.length === 0">
                There are no tags available to select
              </b-dropdown-text>
            </div>
          </b-dropdown>
        </template>
      </b-form-tags>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "TagPicker",
  data() {
    return {
      search: ""
    };
  },
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    options: Array,
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    maxHeight: {
      type: Number,
      default: 400
    }
  },
  computed: {
    criteria() {
      // Compute the search criteria
      return this.search.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      // Filter out already selected options
      const options = this.options.filter(
        opt => this.value.indexOf(opt.name) === -1
      );
      if (criteria) {
        // Show only options that match criteria
        return options.filter(
          opt => opt.name.toLowerCase().indexOf(criteria) > -1
        );
      }
      // Show all options available
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return "There are no tags matching your search criteria";
      }
      return "";
    }
  },
  methods: {
    onOptionClick({ option, addTag }) {
      addTag(option);
      this.search = "";
    }
  }
};
</script>
